

import React from 'react'
import ShopifyData from '../components/shopify-data.js'
import PlanTable from '../components/shopifyPlan.js'
import usePageMeta from '../hooks/usePageMeta';
export default function Shopify() {
    usePageMeta('Shopify Store Development for eCommerce Brands | Spinnennetz', 'Launch or scale your Shopify store with Spinnennetz. We design and develop custom, high-converting Shopify experiences built to grow eCommerce revenue.', '/shopify', {"@context":"https://schema.org","@type":"Service","name":"Shopify Store Development","provider":{"@type":"Organization","name":"Spinnennetz"}}, 'Shopify custom theme development, Shopify experts agency, ecommerce website development, Shopify store redesign, Shopify SEO optimization');
    return (
        <>
            <ShopifyData />
            <PlanTable />
        </>
    )
}
